import { DoctorFeature, Doctor } from '../types';

import { offsetDuplicateCoordinates } from './offsetDuplicateCoordinates';

export function getDoctorFeatures(
  doctors: Doctor[],
  offsetDistance = 0.0001
): DoctorFeature[] {
  const doctorFeatures = doctors.flatMap((doctor: Doctor) =>
    (doctor.clinics || []).flatMap((clinic, idx: number) => {
      if (!clinic.longitude || !clinic.latitude) {
        return [];
      }

      return [
        {
          type: 'Feature' as const,
          id: `${doctor.full_name}_${idx}`,
          geometry: {
            type: 'Point' as const,
            coordinates: [
              parseFloat(clinic.longitude),
              parseFloat(clinic.latitude)
            ] as [number, number]
          },
          properties: {
            full_name: doctor.full_name,
            clinic_address: clinic.address,
            photo: doctor.photo,
            photo_alt: doctor.photo_alt,
            occupation: doctor.occupation,
            qualification: doctor.qualification,
            seniority: doctor.seniority,
            regalia: doctor.regalia,
            bother: doctor.bother,
            city: doctor.city,
            clinics: (doctor.clinics || []).map((clinic) => ({
              name: clinic.name,
              address: clinic.address,
              telephone: clinic.telephone,
              longitude: clinic.longitude,
              latitude: clinic.latitude
            }))
          }
        }
      ];
    })
  );

  return offsetDuplicateCoordinates(
    doctorFeatures,
    offsetDistance
  ) as DoctorFeature[];
}

export type { DoctorFeature };
